import { createContext } from 'react';

const ContentEmbedContext = createContext({
  addScriptEmbeds: () => {},
  removeScriptEmbeds: () => {},
});

export { ContentEmbedContext };
